// Copyright (c) 2023 Deere & Company

import React, {PropTypes} from 'react';
import DuplicatePinPlate from '@deere/cps-it.warranty-model-factory/lib/duplicate-pin-plate';
import DuplicatePinPlateResult from '../duplicate-pin-plate/duplicate-pin-plate-result';
import RefinableListWidget from '../../../../shared/components/refinable-list-widget';
import SearchFilters from '../../../../shared/state/search-filters';
import duplicatePinPlateSortOptions from '../../services/duplicate-pin-plate-sort-options';

const DuplicatePinPlateList = props =>
    <div>
        <RefinableListWidget
            onFilterByChange={props.updateListFilterBy}
            onSortByChange={props.updateListSortBy}
            onSortDirectionChange={props.updateListSortDirection}
            searchFilters={props.duplicatePinPlateSearchFilters}
            sortOptions={duplicatePinPlateSortOptions}
        />
        {props.duplicatePinPlateChanges.map((duplicatePlate, index) =>
            <DuplicatePinPlateResult
                actions={props.actions}
                duplicatePlate={duplicatePlate}
                key={index}
                selectedDealers={props.selectedDealers}
            />
        )}
    </div>;

DuplicatePinPlateList.displayName = 'DuplicatePinPlateList';
DuplicatePinPlateList.propTypes = {
    actions: PropTypes.object.isRequired,
    duplicatePinPlateChanges: PropTypes.arrayOf(PropTypes.instanceOf(DuplicatePinPlate)).isRequired,
    duplicatePinPlateSearchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(String)),
    updateListFilterBy: PropTypes.func.isRequired,
    updateListSortBy: PropTypes.func.isRequired,
    updateListSortDirection: PropTypes.func.isRequired
};

export default DuplicatePinPlateList;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/duplicate-pin-plate/duplicate-pin-plate-list.js